import { Pipe, PipeTransform } from '@angular/core';
import { BudgetService } from '../budget.service';

@Pipe({ name: 'gcSumTotalAvailable' })
export class SumTotalAvailablePipe implements PipeTransform {

  constructor (
    private budgetService: BudgetService
  ) { }

  transform (budgetIds: number[]) {
    return budgetIds.reduce((acc, budgetId) => {
      const budget = this.budgetService.simpleBudgetMap[budgetId];

        return acc + (budget.totalAmountAvailable || 0);
    }, 0);
  }
}
